jQuery(function ($) {

    $('.nab-annuaire__filter--form input[type="checkbox"]').change(filters_search_association);
    
    function filters_search_association(){

        let checkboxes = [];
        let searchEnabled = false;

        $('.checkbox-category').each(function(){
            if($(this).is(':checked')){
                checkboxes.push($(this).val());
            }
        });

        $.ajax({
            url: kreenoot_child.ajax_url,
            type: 'POST',
            data: {
                action: "kl_filter_asso",
                searchEnabled: true,
                checkboxes: checkboxes
            },
            beforeSend: function(){
                $('.nab-annuaire__content').empty('').html(`<p class="search-loading">Chargement..</p>`);
            },
            success: function(response){
                $('.nab-annuaire__content').empty("").html(response);
                console.log(response);
            },
            error: function(xhr, ajaxOptions, thrownError){
                console.error(xhr);
            }
        })

    }

})